export default __webpack_public_path__ + "static/media/2.41670f31.png";